import { render, staticRenderFns } from "./video-view.vue?vue&type=template&id=0476b184&scoped=true"
import script from "./video-view.vue?vue&type=script&lang=js"
export * from "./video-view.vue?vue&type=script&lang=js"
import style0 from "./video-view.vue?vue&type=style&index=0&id=0476b184&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0476b184",
  null
  
)

export default component.exports